// Global Instructions Rule Applied!
import ConfigurationPage from './components/ConfigurationPage.tsx'

export default ConfigurationPage
